import { EntityWidget } from "./EntityWidget";
import { JoineryEntityController } from "../JoineryEntityController";
import { Joinery, SceneConstants } from "@rhinov/savane-js";

export class JoineryEntityWidget extends EntityWidget{

    declare controller: JoineryEntityController;
    declare entity: Joinery;

    handleImageListEvent = (event: MouseEvent) => {
        var elem =  event.currentTarget as HTMLButtonElement & { param?: any };
        if (event.ctrlKey) {
            this.controller.openAssetDetail(elem.param);
            return;
        }
        if (!event.ctrlKey && event.button === 0) {
           
            var index = 0;
            this.controller.allModelsForCurrentJoinery.forEach((modele: any) => {
                let element = document.getElementById(`JoineryModel-${index}`);
                if (element) {
                    element.classList.remove('active');
                }
                index++;
            })
            elem.classList.add('active');
            this.controller.updateJoineryModeleType(elem.param);
            let preview = document.getElementById('previewCurrentJoinery')
            if (preview && preview.getElementsByTagName("img")[0]) {
                preview.getElementsByTagName("img")[0].src = this.controller.itemPreview ?? '';
            }
        }
    }

    constructor(entity: Joinery, panel: any, deliverable: any, openAssetDetailCallback: CallableFunction) {
        super(entity, panel, deliverable, openAssetDetailCallback);
        this.controller = new JoineryEntityController(entity,panel, deliverable, openAssetDetailCallback);
        switch (this.entity.joineryType) {
            case SceneConstants.JoineryType.door:
                this.propertiesTab = ['dropDown', 'buttonToggle', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'range',
                    'range', 'buttonToggle', 'tripleToggle', 'numValueToggle', 'buttonToggle', 'buttonToggle', 'previewJoinery', 'selectJoineryModel'];
                break;
            case SceneConstants.JoineryType.frontDoor:
                this.propertiesTab = ['dropDown', 'buttonToggle', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'range',
                    'range', 'buttonToggle', 'tripleToggle', 'numValueToggle', 'buttonToggle', 'buttonToggle', 'previewJoinery', 'selectJoineryModel'];
                break;
            case SceneConstants.JoineryType.window:
                this.propertiesTab = ['dropDown', 'buttonToggle', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'range', 'range',
                    'buttonToggle', 'buttonToggleShutter', 'numValueToggle', 'numValueToggle', 'tripleToggle', 'buttonToggle', 'buttonToggle', 'previewJoinery', 'selectJoineryModel'];
                break;
            case SceneConstants.JoineryType.opening:
                this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'tripleToggle', 'buttonToggle',
                    'buttonToggle', 'previewJoinery', 'selectJoineryModel'];
                break;
            case SceneConstants.JoineryType.fixedWindow:
                this.propertiesTab = ['dropDown', 'buttonToggle', 'plusLess', 'plusLess', 'plusLess', 'buttonToggleShutter', 'numValueToggle',
                    'numValueToggle', 'tripleToggle', 'buttonToggle', 'buttonToggle', 'previewJoinery', 'selectJoineryModel'];
                break;
            case SceneConstants.JoineryType.velux:
                this.propertiesTab = ['dropDown', 'buttonToggle', 'plusLess', 'plusLess', 'tripleToggle', 'previewJoinery', 'selectJoineryModel'];;
                break;
            case SceneConstants.JoineryType.canopy:
                this.propertiesTab = ['dropDown', 'buttonToggle', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle',
                    'buttonToggleShutter', 'tripleToggle', 'buttonToggle', 'buttonToggle', 'previewJoinery', 'selectJoineryModel'];
                break;
            case SceneConstants.JoineryType.cupboardDoor:
                this.propertiesTab = ['dropDown', 'buttonToggle', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'buttonToggle',
                    'buttonToggle', 'previewJoinery', 'selectJoineryModel'];
                break;
            case SceneConstants.JoineryType.garageDoor:
                this.propertiesTab = ['plusLess', 'plusLess', 'previewJoinery', 'selectJoineryModel'];
                break;
            case SceneConstants.JoineryType.frenchWindow:
                this.propertiesTab = ['dropDown', 'buttonToggle', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'range', 'range',
                    'buttonToggleShutter', 'numValueToggle', 'tripleToggle', 'buttonToggle', 'buttonToggle', 'previewJoinery', 'selectJoineryModel'];
                break;
            case SceneConstants.JoineryType.pictureWindow:
                this.propertiesTab = ['dropDown', 'buttonToggle', 'plusLess', 'plusLess', 'plusLess', 'plusLess',
                    'buttonToggle', 'buttonToggleShutter', 'numValueToggle', 'tripleToggle', 'buttonToggle', 'buttonToggle', 'previewJoinery', 'selectJoineryModel'];
                break;
            case SceneConstants.JoineryType.niche:
                this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'buttonToggle', 'previewJoinery', 'selectJoineryModel'];
                break;
        }
        this.controller.propertiesTab = this.propertiesTab;
    }

    handleImageList(): string {
        var html = "";
        var index = 0;
        this.controller.allModelsForCurrentJoinery.forEach((modele: any) => {
            html += `
                <img id="JoineryModel-${index}" style="display: inline-block;width:180px;height:180px;vertical-align:text-bottom"
                    title="${modele.name}"
                    src="${this.controller.getJoineryPreviewUrl(modele)}"
                    class="${this.controller.isJoineryModelSelected(modele) ? "active" : ""}"></li>
            `;
            index++;
        })
        return html;
    }

    selectJoineryModel(property: any): string {
        return `
            <!--Select model for joineries-->
            <div class="property-item padding tulipImage">
                ${property.title ? `
                    <h style="font-weight:600;">
                        ${property.title}
                    </h>` : ""}
                <div style="margin-bottom:10px;padding:0;width:382px;max-height:650px;overflow-y:auto">
                    ${this.handleImageList()}
                </div>
            </div>
        `;
    }

    setselectJoineryModelListener() {
        var index = 0;
        this.controller.allModelsForCurrentJoinery.forEach((modele: any) => {
            let element = document.getElementById(`JoineryModel-${index}`) as HTMLButtonElement & { param?: any };
            if (element) {
                element.param = modele;
                element.addEventListener('mousedown', this.handleImageListEvent);
            }
            index++;
        })
    }

    removeselectJoineryModelListener() {
        var index = 0;
        this.controller.allModelsForCurrentJoinery.forEach((modele: any) => {
            let element = document.getElementById(`JoineryModel-${index}`);
            if (element) {
                element.removeEventListener('mousedown', this.handleImageListEvent);
            }
            index++;
        })
    }

    previewJoinery(property: any): string {
        return `
            <!-- PREVIEW -->
            <div id="previewCurrentJoinery" class="property-item padding tulipImage">
                ${property.title ? `
                    <h style="font-weight:600;">
                        ${property.title}
                    </h>` : ""}
                <div>
                    <img style="width:180px;height:180px;" src="${!this.controller.itemPreview ? 
                        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/w8AAtEB9U9ViZgAAAAASUVORK5CYII=" : this.controller.itemPreview}" />
                </div>
            </div>
    `;
    }

    setpreviewJoineryListener() {
        let preview = document.getElementById('previewCurrentJoinery');
        if (preview) {
            preview.addEventListener('mousedown', this.previewDetails);
        }
    }

    removepreviewJoineryListener() {
        let preview = document.getElementById('previewCurrentJoinery');
        if (preview) {
            preview.removeEventListener('mousedown', this.previewDetails);
        }
    }


    html(): string {
        var i;
        var html = super.nameHeader() + super.propertyStart();
        for (i = 0; i < this.propertiesTab.length; i++) {
            html += (this as any)[this.propertiesTab[i]](this.panel.properties[i]);
        }
        html += super.propertyEnd();
        return html;
    }
}